export const STOPCHARGE_START = 'STOPCHARGE_START';
export const STOPCHARGE_SUCCESS = 'STOPCHARGE_SUCCESS';
export const STOPCHARGE_ERROR = 'STOPCHARGE_ERROR';
export const STOPCHARGE_LOADING = 'STOPCHARGE_LOADING';
export const STOPCHARGE_CANCEL = 'STOPCHARGE_CANCEL';

export type Actions = {
  STOPCHARGE_START: { type: typeof STOPCHARGE_START; payload: boolean };
  STOPCHARGE_LOADING: { type: typeof STOPCHARGE_LOADING; payload: boolean };
  STOPCHARGE_SUCCESS: { type: typeof STOPCHARGE_SUCCESS; payload: any };
  STOPCHARGE_ERROR: { type: typeof STOPCHARGE_ERROR; payload: any };
  STOPCHARGE_CANCEL: { type: typeof STOPCHARGE_CANCEL; payload: any };
};
// Action Creators
export const actionCreators = {
  stopChargeStart: (payload: any): Actions[typeof STOPCHARGE_START] => ({
    type: STOPCHARGE_START,
    payload,
  }),
  stopChargeError: (payload: any): Actions[typeof STOPCHARGE_ERROR] => ({
    type: STOPCHARGE_ERROR,
    payload,
  }),
  stopChargeSuccess: (payload: any): Actions[typeof STOPCHARGE_SUCCESS] => {
    return ({ type: STOPCHARGE_SUCCESS, payload: payload});
  }
  ,
  stopChargeLoading: (payload: boolean): Actions[typeof STOPCHARGE_LOADING] => ({
    type: STOPCHARGE_LOADING,
    payload,
  }),
  stopChargeCancel: (payload: boolean): Actions[typeof STOPCHARGE_CANCEL] => ({
    type: STOPCHARGE_CANCEL,
    payload,
  }),
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/accounts/stopcharge/actions.ts